/**
 * Whether the current page load should render the wedding sub-site instead of
 * the Brickn app. True when running on attend.nu (or a subdomain) *or* when
 * the path is the legacy /bröllop route on any other domain.
 */
export function isWeddingContext(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  if (host === 'attend.nu' || host.endsWith('.attend.nu')) return true;

  let path = window.location.pathname;
  try { path = decodeURIComponent(path); } catch { /* keep raw */ }
  // The event platform (events, invitations, dashboard, legacy wedding routes)
  // works on any domain via these paths; only the product landing at "/" is
  // attend.nu-only. Keeping these here makes invitation links resolve anywhere.
  return (
    path === '/bröllop' || path === '/brollop' ||
    path.startsWith('/bröllop/') || path.startsWith('/brollop/') ||
    path.startsWith('/e/') || path.startsWith('/i/') ||
    path === '/dashboard' || path === '/events' || path === '/mina-event' ||
    path === '/osa' || path === '/admin'
  );
}

/** True when running on attend.nu (or a subdomain thereof). */
export function isAttendNuHost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  return host === 'attend.nu' || host.endsWith('.attend.nu') || host === 'localhost';
}
